import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent, Grid, Typography } from '@mui/material';
import { SelectLanguage } from 'components/_commons/Form/Inputs';
import { ModalProps } from 'hooks/ModalProvider';
import React, { useCallback, useEffect, useState } from 'react';
import { i18nStore } from 'stores';
import { translate } from 'utils';
import { iconEnum } from 'utils/icons';
import { CustomActionButtons } from './_CustomActionButtons';
import { ModalHeader } from './_ModalHeader';

export const ChangeLanguageModal = ({
  onSubmit, onClose, defaultValues
}: ModalProps<any>) => {
  const [language, setLanguage] = useState(null);
  const [isSavingLanguage, setIsSavingLanguage] = useState(false);
  const { languageList } = i18nStore;

  useEffect(() => {
    if (languageList.length > 0 && defaultValues) {
      setLanguage(languageList.find((lg) => lg.value.toUpperCase().indexOf(defaultValues.toUpperCase()) !== -1));
    }
  }, [languageList, defaultValues]);

  const handleSelectLanguage = useCallback((value) => setLanguage(value), []);

  const handleValidateModal = useCallback((e) => {
    e.preventDefault();

    onSubmit(language, setIsSavingLanguage);
  }, [onSubmit, language, setIsSavingLanguage]);

  return (
    <form onSubmit={handleValidateModal}>
      <ModalHeader onClose={onClose}>
        <FontAwesomeIcon icon={iconEnum.globe.icon as any} />
        <Typography component="span">
          {translate('modalChangeLanguage.title')}
        </Typography>
      </ModalHeader>

      <DialogContent>
        <Grid container direction="column">
          <br />
          <SelectLanguage
            languages={languageList}
            required
            value={language}
            onChange={handleSelectLanguage}
          />
        </Grid>
      </DialogContent>

      <CustomActionButtons isSaving={isSavingLanguage} onClose={onClose} />
    </form>
  );
};
